<template>
    <NuxtLayout name="main">
        <module-navigations />

        <div :class="css.container">
            <ColumnLayout :class="css.content" class="container">
                <!-- * 统计结果 -->
                <div :class="css.statistics" class="font-variable" ref="container">
                    <template v-if="!keyword">{{ $t("Layout.PaginationStatistics", { count: count }) }}</template>
                    <i18n-t v-else scope="global" keypath="SearchResultPlaceholder">
                        <template v-slot:number>{{ count }}</template>
                        <template v-slot:keyword>
                            <span>{{ keyword }}</span>
                        </template>
                    </i18n-t>
                </div>

                <!-- * 表格 -->
                <SearchDiagram :class="css.table" v-on="ons.diagram" ref="table" :data="data" :option="option" :placeholder="$t('NoData')">
                    <template #noResult>
                        <div>
                            <i18n-t keypath="SearchNoResult">
                                <template #keyword>
                                    <span :class="css.keyword" class="ellipsis">{{ keyword }}</span>
                                </template>
                            </i18n-t>
                        </div>
                    </template>
                    <template #name="{ data }">
                        <div class="ellipsis">{{ data.full_name }}</div>
                    </template>

                    <template #gene="{ data }">
                        <div class="ellipsis" v-html="data.rel_gene_name"></div>
                    </template>

                    <template #rare="{ data }">
                        <span style="color: #ce2424" v-if="data.is_rare">✔</span>
                    </template>

                    <template #inheritance="{ data }">
                        <div :class="css.inheritance">
                            <div :class="css[value.color_type]" v-for="(value, key) in data.inheritance_tag" :key="key" :title="value.value">
                                {{ value.tag }}
                            </div>
                        </div>
                    </template>

                    <template #categories="{ data }">
                        <div :class="css.categories">
                            <UiTooltip :class="css.categorie" direction="bottom" v-for="value in data.categories_icon">
                                <img :src="value.icon" alt="" />
                                <template #content>
                                    {{ value.value }}
                                </template>
                            </UiTooltip>
                        </div>
                    </template>
                </SearchDiagram>

                <!-- * 分页器 -->
                <UiPagination v-if="count > 20" v-model="page" :count="count" :limit="20" @change="methods.data()">
                    <template #items> {{ $t("Layout.PaginationDetails", { count: count, limit: 20 }) }}</template>
                </UiPagination>

                <template #aside>
                    <!-- * 标题 -->
                    <DefaultName>{{ $route.meta.name ? $t($route.meta.name) : "" }}</DefaultName>
                    <!-- * 筛选器 -->
                    <div :class="css.selectors">
                        <div :class="css.selector" v-for="(value, key) in selector" :key="key">
                            <!-- * 全选按钮 -->
                            <ui-checkbox
                                :class="css.checkbox"
                                v-model="value.selector"
                                value=""
                                @change="methods.selectors(value)"
                                :title="value.name">
                                <h3 :class="css.name" class="font-bold font-variable color-1 ellipsis">{{ value.name }}</h3>
                            </ui-checkbox>

                            <!-- * 特殊单选项 -->
                            <template v-if="value.key == 'inheritances.name'">
                                <UiCheckboxGroup :class="css.inheritances" v-model="value.result" @change="methods.selector(value)">
                                    <template v-for="(opt, index) in value.options" :key="index">
                                        <ui-checkbox :class="css.checkbox" :value="opt.value" :title="opt?.full_name">
                                            <h4 :class="css[opt.color_type]">{{ opt.label }}</h4>
                                        </ui-checkbox>
                                    </template>
                                </UiCheckboxGroup>
                            </template>

                            <!-- * 常规单选项 -->
                            <template v-else>
                                <UiCheckboxGroup :class="css.checkboxs" v-model="value.result" @change="methods.selector(value)">
                                    <template v-for="(opt, index) in value.options" :key="index">
                                        <ui-checkbox :class="css.checkbox" :value="opt.value" :title="opt.label">
                                            <h4 v-if="!opt.icon" class="ellipsis">{{ opt.label }}</h4>
                                            <h4 v-else :class="css.align">
                                                <img :class="css.icon" :src="opt.icon" :alt="opt.value" />
                                                <div :class="css.context" class="ellipsis">{{ opt.label }}</div>
                                            </h4>
                                        </ui-checkbox>
                                    </template>
                                </UiCheckboxGroup>
                            </template>
                        </div>
                    </div>
                </template>
            </ColumnLayout>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTooltip, UiCheckbox, UiPagination, UiCheckboxGroup } from "various-ui";
//* 公共组件
import { ColumnLayout, DefaultName } from "@/components/complete";
import { SearchDiagram } from "@/components/visualizations";
//* 私有公共组件
import ModuleNavigations from "../../components/navigations/index.vue";
//* 组件属性
import { useComposable } from "../src/composable";
import { useDiseaseOption } from "../src/options";
//* 样式
import css from "../style/index.module.less";

//* 组合函数
const { ons, refs, nodes, watchs, methods } = useComposable("disease");
const { container } = nodes;
const { data, page, count, keyword, selector } = refs;

//* 配置项
const option = useDiseaseOption();

//* 组件挂载初始化
onMounted(() => methods.init());
//* 组件卸载前, 移除loading
onBeforeUnmount(() => watchs?.stop());
</script>
